import React, { Component } from 'react';
import { batch, connect, useDispatch } from 'react-redux';
import cn from 'classnames';
import { compose } from 'redux';
import { Field, reduxForm, change, submit, formValues } from 'redux-form';
import Sticky from 'react-sticky-el';

import {
  loadProfile,
  updateProfile,
  uploadPhoto,
  createProfile,
  loadAgentProfile,
  updateAgentProfile,
  uploadAgentPhoto,
  loadCompanyProfiles,
} from 'actions/profile';
import { ROOT_URL } from 'constants/Config';
import s from '../Profile.scss';
import Avatar from '../Avatar/Avatar';
import Social from '../Social';
import { setPopUp } from 'actions/environment';
import AvatarUploader from '../AvatarUploader';
import iconUser from 'assets/images/icons/icon-user-sq.svg';
import { normalizePhone } from './utils';
import Input from './Input';
import Textarea from './Textarea';
import validate from './validate';
import { withTranslation } from 'react-i18next';
import { leaveProfileAgency } from 'actions/profile';
import LeaveAgencyDialog from '../LeaveAgency/LeaveAgencyDialog';
import loader from 'assets/images/loader.svg';
import { checkUserPhone } from '../../../actions/profile';
import { InformPopupContent } from '../InformPopup/InformPopup';
import debounce from 'lodash.debounce';
import { gaEvent, trackGA } from 'services/ga';

class SaveButton extends Component {
  render() {
    const { t, profile, onProfileSave } = this.props;

    return (
      <button
        className={cn(s.ButtonSave, 'button-primary', 'button-primary--lg')}
        onClick={() => {
          if (profile) {
            trackGA(
              gaEvent.profileButtonsClick({
                eventLabel: 'sohranit_izmeneniya',
                user_id: profile.id,
              })
            );
          }
          onProfileSave();
        }}
      >
        {t('components.profile.profileForm.saveButton')}
      </button>
    );
  }
}

const ProfileFormSaveButton = connect(
  ({ form }) => (form.ProfileForm && form.ProfileForm.values) || {}
)(withTranslation()(SaveButton));

class LeaveAgencyButton extends Component {
  handleClick = (profile) => {
    trackGA(
      gaEvent.profileButtonsClick({
        eventLabel: 'vyiti_iz_agentstva',
        user_id: profile.id,
      })
    );

    this.props.setPopUp(<LeaveAgencyDialog />, {
      closeStyleName: 'Default',
      contentStyleName: 'Default',
      closeIcon: 'default',
      lockScroll: false,
    });
  };

  render() {
    const { t, profile } = this.props;

    return (
      <button
        type="button"
        className={cn(s.ButtonSave, 'button-default', 'button-primary--lg')}
        onClick={() => this.handleClick(profile)}
      >
        {t('components.profile.profileForm.leaveAgency')}
      </button>
    );
  }
}

const mapDispatchToPropsLeaveAgency = {
  leaveProfileAgency,
  setPopUp,
};

const mapStateToPropsLeaveAgency = (state) => ({
  profile: state.profile,
});

const ProfileFormLeaveAgencyButton = connect(
  mapStateToPropsLeaveAgency,
  mapDispatchToPropsLeaveAgency
)(withTranslation()(LeaveAgencyButton));

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phones: 1,
      avatarId: props.avatarId,
      isChecking: false,
      isPhoneChecked: false,
      userActive: true,
      userIncludedToAgency: formValues,
    };

    this.debouncedTrackGA = debounce(this.trackInputEvent, 3000);

    this.debouncedEnterNameEvent = debounce(this.trackInputEvent.bind(this, 'imya'), 3000);
    this.debouncedEnterSurnameEvent = debounce(this.trackInputEvent.bind(this, 'familiya'), 3000);
    this.debouncedEnterPhoneEvent = debounce(this.trackInputEvent.bind(this, 'telefon'), 3000);
    this.debouncedEnterEmailEvent = debounce(this.trackInputEvent.bind(this, 'email'), 3000);
    this.debouncedEnterPositionEvent = debounce(this.trackInputEvent.bind(this, 'dolzhnost'), 3000);
    this.debouncedEnterCompanyEvent = debounce(this.trackInputEvent.bind(this, 'kompaniya'), 3000);
    this.debouncedEnterDescriptionEvent = debounce(this.trackInputEvent.bind(this, 'o_sebe'), 3000);

    this.debouncedEnterVkEvent = debounce(this.trackInputEvent.bind(this, 'vkontakte'), 3000);
    this.debouncedEnterOkEvent = debounce(this.trackInputEvent.bind(this, 'odnoklassniki'), 3000);
    this.debouncedEnterFbEvent = debounce(this.trackInputEvent.bind(this, 'facebook'), 3000);
    this.debouncedEnterInstEvent = debounce(this.trackInputEvent.bind(this, 'instagram'), 3000);
    this.debouncedEnterYtEvent = debounce(this.trackInputEvent.bind(this, 'youtube'), 3000);
  }

  UNSAFE_componentWillMount() {
    const { agentId } = this.props;
    if (agentId) {
      this.props.loadAgentProfile({ hash: agentId });
    } else {
      this.props.loadProfile({});
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.avatarId && nextProps.avatarId !== this.state.avatarId) {
      this.setState({ avatarId: nextProps.avatarId });
    }
    if (nextProps.isLoaded && !this.props.isLoaded && nextProps.agentId) {
      this.props.dispatch(change('ProfileForm', 'agencyId', nextProps.profile.agencyId));
      this.props.dispatch(change('ProfileForm', 'agencyName', nextProps.profile.agencyName));
    }
  }

  handleAddPhoneClick = () => this.setState({ phones: this.state.phones + 1 });

  onLoadPhoto = ({ preview, file }) => {
    const { uploadPhoto, setPopUp, profileForm } = this.props;
    const { avatarId } = this.state;
    setPopUp(
      <AvatarUploader
        file={file}
        preview={preview}
        onSave={(file) => {
          const data = new FormData();
          data.append('file', file);
          setPopUp();

          this.props.uploadPhoto(data).then((res) => {
            const avatarId = res.response.data.data.imageId;
            this.setState({ avatarId });
            // this.submitFormAsAdditionalData(avatarId);
          });
        }}
      />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      }
    );
  };

  onLoadHashPhoto = ({ preview, file }) => {
    const { uploadAgentPhoto, setPopUp, profileForm } = this.props;
    const { avatarId } = this.state;
    setPopUp(
      <AvatarUploader
        file={file}
        preview={preview}
        onSave={(file) => {
          const data = new FormData();
          data.append('file', file);
          setPopUp();

          this.props.uploadAgentPhoto(data).then((res) => {
            const avatarId = res.response.data.data.imageId;
            this.setState({ avatarId });
            // this.submitFormAsAdditionalData(avatarId);
          });
        }}
      />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      }
    );
  };

  trackInputEvent(inputName) {
    trackGA(gaEvent.profileFormInput({ eventLabel: inputName, user_id: this.props.profile.id }));
  }

  profileErrorsShow(errorName) {
    trackGA(
      gaEvent.profileSaveSuccessAndErrorsShow({
        eventContent: errorName,
        eventLabel: 'oshibka',
        user_id: this.props.profile.id,
      })
    );
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    if (!this.props.popup && value.length >= 2) {
      switch (name) {
        case 'firstName':
          this.debouncedEnterNameEvent();
          break;
        case 'lastName':
          this.debouncedEnterSurnameEvent();
          break;
        case 'email':
          this.debouncedEnterEmailEvent();
          break;
        case 'position':
          this.debouncedEnterPositionEvent();
          break;
        case 'company':
          this.debouncedEnterCompanyEvent();
          break;
        case 'description':
          this.debouncedEnterDescriptionEvent();
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case 'firstName':
          this.debouncedEnterNameEvent.cancel();
          break;
        case 'lastName':
          this.debouncedEnterSurnameEvent.cancel();
          break;
        case 'email':
          this.debouncedEnterEmailEvent.cancel();
          break;
        case 'position':
          this.debouncedEnterPositionEvent.cancel();
          break;
        case 'company':
          this.debouncedEnterCompanyEvent.cancel();
          break;
        case 'description':
          this.debouncedEnterDescriptionEvent.cancel();
          break;
        default:
          break;
      }
    }
  };

  handleProfileSave = () => {
    const { profileForm } = this.props;

    if (profileForm && profileForm.syncErrors) {
      const errorFields = Object.keys(profileForm.syncErrors);

      // if (errorFields.length) {
      //   this.profileErrorsShow('polya_zapolneny_nekorrektno');
      // }

      errorFields.forEach((field) => {
        let errorEventLabel;

        switch (field) {
          case 'firstName':
            errorEventLabel = 'nevernoe_imya';
            break;
          case 'lastName':
            errorEventLabel = 'nevernaya_familiya';
            break;
          case 'email':
            errorEventLabel = 'nevernyi_email';
            break;
          case 'phone':
            errorEventLabel = 'nevernyi_telefon';
            break;
          case 'position':
            errorEventLabel = 'nevernoe_zvanie';
            break;
          case 'company':
            errorEventLabel = 'nekorrektnaya_kompaniya';
            break;
          case 'description':
            errorEventLabel = 'nekorrektnoe_opisanie';
            break;
          default:
            errorEventLabel = 'nekorrektnoe_pole';
            break;
        }

        this.profileErrorsShow(errorEventLabel);
      });
    }
  };

  checkUserPhone = async (data) => {
    this.setState({ isChecking: true });

    try {
      const result = await this.props.checkUserPhone(data);

      const { active, includedToAgency } = result.data;
      const { setPopUp, dispatch, agencyId } = this.props;

      const popupParams = {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      };

      const setAgentDataIntoForm = async () => {
        const { id } = result.data.user;
        const { onGoToEdit } = this.props;
        onGoToEdit({ agentId: id, agencyId });
      };

      if (active) {
        if (includedToAgency) {
          setPopUp(<InformPopupContent type={'userBindedToAgency'} />, popupParams);
          dispatch(change('ProfileForm', 'phone', ''));
        } else {
          setPopUp(
            <InformPopupContent
              type={'userAlreadyExists'}
              onOkButtonClick={setAgentDataIntoForm}
            />,
            popupParams
          );
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isChecking: false, isPhoneChecked: true });
    }
  };

  componentDidUpdate(prevProps) {
    const { profileForm, agencyId } = this.props;

    if (profileForm && profileForm.values) {
      const { phone, vk, ok, facebok, instagram, youtube } = profileForm.values;

      if (phone && prevProps.profileForm && prevProps.profileForm.values) {
        if (phone !== prevProps.profileForm.values.phone) {
          if (phone.length >= 3) {
            this.debouncedEnterPhoneEvent();
          } else {
            this.debouncedEnterPhoneEvent.cancel();
          }
          if (phone.length === 11) {
            this.setState({ isPhoneChecked: false }, () => {
              if (!this.state.isPhoneChecked) {
                this.checkUserPhone({ phone, agencyId });
              }
            });
          }
        }
        if (vk && vk !== prevProps.profileForm.values.vk && vk.length >= 2) {
          this.debouncedEnterVkEvent();
        } else {
          this.debouncedEnterVkEvent.cancel();
        }
        if (ok && ok !== prevProps.profileForm.values.ok && ok.length >= 2) {
          this.debouncedEnterOkEvent();
        } else {
          this.debouncedEnterOkEvent.cancel();
        }
        if (facebok && facebok !== prevProps.profileForm.values.facebok && facebok.length >= 2) {
          this.debouncedEnterFbEvent();
        } else {
          this.debouncedEnterFbEvent.cancel();
        }
        if (
          instagram &&
          instagram !== prevProps.profileForm.values.instagram &&
          instagram.length >= 2
        ) {
          this.debouncedEnterInstEvent();
        } else {
          this.debouncedEnterInstEvent.cancel();
        }
        if (youtube && youtube !== prevProps.profileForm.values.youtube && youtube.length >= 2) {
          this.debouncedEnterYtEvent();
        } else {
          this.debouncedEnterYtEvent.cancel();
        }
      }
    }
  }

  submitFormAsAdditionalData(avatarId) {
    const {
      isNew,
      agentId,
      agencyId,
      updateProfile,
      updateAgentProfile,
      createProfile,
      profileForm,
    } = this.props;
    this.setState({ avatarId });

    const values = profileForm.values;

    if (isNew) {
      this.createAgentProfileWithUpdatingList({ ...values, avatarId, agencyId });
    } else if (agentId) {
      this.updateAgentProfileWithUpdatingList({ ...values, avatarId, userHash: agentId });
    } else {
      updateProfile({ ...values, avatarId });
    }
  }

  updateAgentProfileWithUpdatingList = async ({ userHash, avatarId, ...other }) => {
    await this.props.updateAgentProfile({ ...other, avatarId, userId: userHash });
    // FIXME: move it to redux
    this.props.loadCompanyProfiles({});
  };

  createAgentProfileWithUpdatingList = async ({ agencyId, avatarId, ...other }) => {
    await this.props.createProfile({ ...other, avatarId, agencyId, roleId: '13' });
    // FIXME: move it to redux
    this.props.loadCompanyProfiles({});
  };

  render() {
    const {
      handleSubmit,
      updateProfile,
      updateAgentProfile,
      createProfile,
      initialValues,
      agentId,
      isLoaded,
      isNew,
      agencyId,
      roleName,
      popup,
      onSave,
      t,
      profile,
      profileForm,
    } = this.props;
    const { avatarId, isChecking } = this.state;
    const hasPermission =
      isNew || agentId || roleName === 'admin' || roleName === 'owner' || !agencyId;

    if (isNew || (initialValues && isLoaded)) {
      return (
        <form
          onSubmit={handleSubmit((props) =>
            (isNew
              ? this.createAgentProfileWithUpdatingList({ ...props, avatarId, agencyId })
              : agentId
              ? this.updateAgentProfileWithUpdatingList({ ...props, avatarId, userHash: agentId })
              : updateProfile({ ...props, avatarId })
            ).then(() => {
              onSave && onSave();
            })
          )}
          className={cn(s.Inner, { [s.PopupInner]: popup })}
        >
          <div className={cn(s.FormInner, { [s.PopupFormInner]: popup }, 'custom-scrollbar')}>
            <div
              className={s.AvatarWrapper}
              onClick={() => {
                if (profile) {
                  trackGA(
                    gaEvent.profileButtonsClick({
                      eventLabel: 'obnovit_foto',
                      user_id: this.props.profile.id,
                    })
                  );
                }
              }}
            >
              <Avatar
                src={
                  avatarId ? `${ROOT_URL}/image/get?id=${avatarId}&preset=avatar_edit` : iconUser
                }
                onLoadPhoto={agentId || isNew ? this.onLoadHashPhoto : this.onLoadPhoto}
                popup={popup}
              />
            </div>
            <div className={cn(s.Section, s.SectionInputs)}>
              <div className={s.InputWrap}>
                <Field
                  name="firstName"
                  component={Input}
                  label={t('components.profile.profileForm.firstName')}
                  placeholder={t('components.profile.profileForm.firstNameLabel')}
                  id="name"
                  required
                  disabled={!hasPermission}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="lastName"
                  component={Input}
                  label={t('components.profile.profileForm.lastName')}
                  placeholder={t('components.profile.profileForm.lastNameLabel')}
                  id="surname"
                  required
                  disabled={!hasPermission}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className={s.PhoneInputWrap}>
                <Field
                  name="phone"
                  component={Input}
                  type="tel"
                  label={t('components.profile.profileForm.phone')}
                  placeholder="+7"
                  mask="+\7 (111) 111-11-11"
                  id="phone"
                  required
                  disabled={!isNew && popup}
                  normalize={normalizePhone}
                  onChange={this.handleInputChange}
                />
                {isChecking && <img className={s.Loader} src={loader} />}
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="email"
                  component={Input}
                  type="email"
                  label={t('components.profile.profileForm.email')}
                  placeholder="example@gmail.com"
                  id="email"
                  required
                  disabled={!hasPermission}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="position"
                  component={Input}
                  label={t('components.profile.profileForm.position')}
                  placeholder={t('components.profile.profileForm.positionPlaceholder')}
                  id="position"
                  required
                  disabled={!hasPermission}
                  onChange={this.handleInputChange}
                />
              </div>
              {!isNew && (
                <div className={s.InputWrap}>
                  <Field
                    name={agencyId ? 'agencyName' : 'company'}
                    component={Input}
                    label={t('components.profile.profileForm.company')}
                    placeholder={t('components.profile.profileForm.companyPlaceholder')}
                    required
                    disabled={!!agencyId}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}
            </div>
            <div className={cn(s.Section, s.SectionTextarea)}>
              <Field
                name="description"
                component={Textarea}
                label={t('components.profile.profileForm.about')}
                placeholder={t('components.profile.profileForm.aboutPlaceholder')}
                id="description"
                maxLength={250}
                onChange={this.handleInputChange}
              />
            </div>
            <div className={cn(s.Section, s.SectionSocial)}>
              <Social />
            </div>
          </div>
          {popup ? (
            <ProfileFormSaveButton popup />
          ) : (
            <Sticky mode="bottom" className={s.ButtonsWrap} stickyClassName={s.ButtonsWrapSticky}>
              {agencyId && <ProfileFormLeaveAgencyButton popup />}
              <ProfileFormSaveButton
                popup
                profile={profile}
                onProfileSave={this.handleProfileSave}
              />
            </Sticky>
          )}
        </form>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ profile, agentProfile, form }, { agentId, isNew, agencyId }) => {
  const passProfile = agentId ? agentProfile : profile;

  const res = isNew
    ? {
        agencyId: passProfile && passProfile.agencyId,
      }
    : {
        initialValues: undefined,
        avatarId: passProfile && passProfile.avatarId,
        isLoaded: passProfile && passProfile.isLoaded,
        agencyId: passProfile && passProfile.agencyId,
        roleName: passProfile && passProfile.roleName,
        profile,
      };
  if (!passProfile.isLoaded || (agentId && passProfile.id !== agentId)) {
    return {
      ...res,
      profileForm: form.ProfileForm,
    };
  }
  return {
    ...res,
    initialValues: isNew ? {} : passProfile,
    profileForm: form.ProfileForm,
  };
};

const mapDispatchToProps = {
  setPopUp,
  loadProfile,
  updateProfile,
  uploadPhoto,
  loadAgentProfile,
  updateAgentProfile,
  uploadAgentPhoto,
  createProfile,
  loadCompanyProfiles,
  checkUserPhone,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'ProfileForm',
    validate,
  })
)(withTranslation()(Profile));



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/ProfileForm.js